<dls-multiselect [(ngModel)]="filter.selectedValue.value" [maxSelectedLabels] ="maxSelectedLabels" name="data" [enableSelectAllHeader]="enableSelectAllHeader" >
    <dls-multiselect-option *ngFor="let data of filter.config.values" [value]="data">
            <span class="pt-option-label">{{data?.label}}</span>
    </dls-multiselect-option>
</dls-multiselect>